import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useSolutionContext } from '../../context/Solution/SolutionContext';
import Api from 'Api/Api';
import { url } from '@api-config';
import { fullIngestionStatusKeys } from './useFullIngestionStatus.query';
import { IngestionLogCountsQueryKey } from './useIngestionLogCounts.query';
import { useLocation } from 'react-router';
import { ingestionLogsKeys } from './useIngestionLogSummary.query';

export const useFullIngestionActions = () => {
  const { solution } = useSolutionContext();
  const id = solution?.id;
  const query = useQueryClient();
  const { pathname } = useLocation();

  const invalidateQueries = () => {
    // if the ingestion logs are open, fetch the latest logs so the list is updated
    if (pathname.includes('ingestion')) {
      query.invalidateQueries({
        queryKey: ingestionLogsKeys.all,
      });
    }
    query.invalidateQueries({ queryKey: IngestionLogCountsQueryKey });
    query.invalidateQueries({ queryKey: fullIngestionStatusKeys.invalidationKey });
  };

  const run = useMutation<void, Error>({
    mutationFn: () => Api.get(`${url.startIngestion}/${id}`),
    onSuccess: () => {
      invalidateQueries();
    },
  });

  const stop = useMutation<void, Error, number>({
    mutationFn: (ingestionId) => Api.get(`${url.stopIngestion}/${id}/${ingestionId}`),
    onSuccess: () => {
      invalidateQueries();
    },
  });

  return {
    runIngestion: run.mutate,
    stopIngestion: stop.mutate,
  };
};
